import React from 'react'
import { DesktopDatePicker } from '@mui/x-date-pickers'
import EventIcon from 'components/material-symbol/icons/Event'
import {
  mergeDesktopDatePickerSlotProps,
  mergeDesktopDatePickerSlots,
} from './desktop-date-picker'

const DatePickerIcon = props => <EventIcon fill={0} {...props} />

const PgaMobileDatePicker = ({
  label,
  value,
  onAccept,
  onChange,
  format,
  validationErrors,
  slotProps,
  slots,
  ...rest
}) => {
  const { helperText, ...pickerRest } = rest

  return (
    <DesktopDatePicker
      label={label}
      value={value}
      format={format}
      onChange={onChange}
      onAccept={onAccept}
      dayOfWeekFormatter={day => `${day}`}
      closeOnSelect
      slots={mergeDesktopDatePickerSlots({
        openPickerIcon: DatePickerIcon,
        ...slots,
      })}
      slotProps={mergeDesktopDatePickerSlotProps({
        ...slotProps,
        textField: {
          error: Boolean(validationErrors),
          helperText,
          ...slotProps?.textField,
        },
      })}
      {...pickerRest}
    />
  )
}

export default PgaMobileDatePicker
